const isDark = useDark();
if (typeof localStorage !== 'undefined' && localStorage.getItem('theme')) {
  localStorage.getItem('theme') === 'dark' ? isDark.value = true : isDark.value = false;
} else {
  isDark.value = true;
}
export function getTheme() {
  return {
    isDark
  };
}
export function setTheme(val) {
  val === 'dark' ? isDark.value = true : isDark.value = false;
  localStorage.setItem('theme', val);
  if (val == 'dark') {
    document.body.style.backgroundColor = '#28282e';
  } else {
    document.body.style.backgroundColor = '#fff';
  }
}